

<div class="vh-100">
  <kp-header></kp-header>
  <div id="wrapper" class="toggled vh-100">
      <kp-left-nav></kp-left-nav>
      <div id="content-wrapper" class="page-content-wrapper w-100 h-100">
          <kp-content></kp-content>
          <router-outlet />
      </div>
  </div>
</div>
